import React from 'react';
import { FaGlobe, FaApple, FaAndroid, FaExternalLinkAlt } from 'react-icons/fa';
import './LatestProject.css';
import driverspotLogo from '../assets/logowhite.png';

const LatestProject = () => {
  return (
    <section id="latest-project" className="latest-project">
      <div className="latest-project-container">
        <div className="latest-project-header" data-aos="fade-up">
          <h2 className="section-title">Our Latest Project</h2>
          <p className="section-subtitle">
            Check out DriverSpot - A revolutionary driver booking platform
          </p>
        </div>
        <div className="project-card" data-aos="fade-up" data-aos-delay="200">
          <div className="project-content">
            <div className="project-header-section">
              <div className="project-logo-container">
                <img src={driverspotLogo} alt="DriverSpot Logo" className="project-logo" />
              </div>
              <div className="project-badge">
                <span>🚀 Featured Project</span>
              </div>
            </div>
            
            <div className="project-main-content">
              <div className="project-info">
                <h3 className="project-title">DriverSpot</h3>
                <p className="project-tagline">Spot Driver at DriverSpot</p>
                <p className="project-description">
                  DriverSpot connects you with professional, trained drivers for your personal vehicle. 
                  Schedule rides for city travel, outstation trips, or after-party pickups. Choose drivers 
                  by language and vehicle type for a comfortable, reliable experience.
                </p>
                <div className="project-features">
                  <div className="project-feature">
                    <span>Verified & Trained Drivers</span>
                  </div>
                  <div className="project-feature">
                    <span>On-Demand & Scheduled Bookings</span>
                  </div>
                  <div className="project-feature">
                    <span>Real-time Tracking & Safety</span>
                  </div>
                  <div className="project-feature">
                    <span>Refer & Earn Program</span>
                  </div>
                </div>
              </div>
              
              <div className="project-links">
                <a
                  href="https://driverspot.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link website"
                  data-aos="zoom-in"
                  data-aos-delay="300"
                >
                  <div className="link-icon-wrapper">
                    <FaGlobe className="link-icon" />
                  </div>
                  <div className="link-content">
                    <span className="link-label">Visit Website</span>
                    <span className="link-url">driverspot.in</span>
                  </div>
                  <FaExternalLinkAlt className="external-icon" />
                </a>
                <a
                  href="https://apps.apple.com/in/app/driverspot/id6738885386"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link ios"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                >
                  <div className="link-icon-wrapper">
                    <FaApple className="link-icon" />
                  </div>
                  <div className="link-content">
                    <span className="link-label">Download on</span>
                    <span className="link-url">App Store</span>
                  </div>
                  <FaExternalLinkAlt className="external-icon" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.sunanthsamala.rentadriver&pcampaignid=web_share&pli=1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link android"
                  data-aos="zoom-in"
                  data-aos-delay="500"
                >
                  <div className="link-icon-wrapper">
                    <FaAndroid className="link-icon" />
                  </div>
                  <div className="link-content">
                    <span className="link-label">Get it on</span>
                    <span className="link-url">Google Play</span>
                  </div>
                  <FaExternalLinkAlt className="external-icon" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestProject;

